export default {
  name: 'SideNaLink',
  template: '#side-nav-group-template',
  data () {
    return {
      includeWrapper: true
    }
  },
  props: ['route', 'text', 'amount'],
  mounted () {
    if (this.$children.length > 1) {
      this.includeWrapper = false // remove the <ul> wrapper around the <slot> if there aren't any child links
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/side-nav/SideNavGroup.js